import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./collapseCard.scss";
const CollapseCard = ({
  title,
  defaultOpen = true,
  open: controlledOpen,
  onToggle,
  accentColor,
  className = "",
  bodyClassName = "p-2",
  headerRight = null,
  children,
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
  const isControlled = controlledOpen !== undefined;
  const isOpen = isControlled ? controlledOpen : uncontrolledOpen;

  const toggle = () => {
    const next = !isOpen;
    if (isControlled) {
      onToggle?.(next);
    } else {
      setUncontrolledOpen(next);
    }
  };

  return (
    <div
      className={`card collapse-card ${isOpen ? "open" : ""} ${className}`}
      style={accentColor ? { "--collapse-accent": accentColor } : undefined}
    >
      <div className="collapse-card-header" onClick={toggle}>
        <div className="collapse-card-title">
          {typeof title === "string" ? <h5>{title}</h5> : title}
        </div>

        <div className="collapse-card-header-right">
          {headerRight}
          <button
            type="button"
            className="collapse-card-icon"
            onClick={(e) => {
              e.stopPropagation();
              toggle();
            }}
            aria-label={isOpen ? "Collapse" : "Expand"}
          >
            <ChevronDown size={20} />
          </button>
        </div>
      </div>

      <div className="collapse-card-content">
        <div className={`card-body ${bodyClassName}`}>{children}</div>
      </div>
    </div>
  );
};

export default CollapseCard;